import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateApiKey = async (apiKeyId, details) => {
  const apiURL = API_HOST + '/api_keys/' + apiKeyId;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.patch(apiURL,{
      api_key:{
        ...details
      }
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
